const setFolders = (state, payload) => {
  state.folders = payload
}

const setCurrentFolderDepth = (state, payload) => {
  state.currentFolderDepth = payload
}

export default {
  setFolders,
  setCurrentFolderDepth,
}
